import { render, staticRenderFns } from "./SideCabinets.vue?vue&type=template&id=71a50bff&scoped=true"
import script from "./SideCabinets.vue?vue&type=script&lang=js"
export * from "./SideCabinets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a50bff",
  null
  
)

export default component.exports